// Lists of adjectives and nouns for generating random anonymous names
const adjectives = [
  'Mighty', 'Swift', 'Clever', 'Bold', 'Fierce', 'Gentle', 'Bright', 'Dark',
  'Golden', 'Silver', 'Crimson', 'Azure', 'Emerald', 'Purple', 'Orange', 'Pink',
  'Blazing', 'Frozen', 'Thunder', 'Lightning', 'Storm', 'Calm', 'Wild', 'Tame',
  'Ancient', 'Modern', 'Mystic', 'Magic', 'Secret', 'Hidden', 'Visible', 'Clear',
  'Fuzzy', 'Sharp', 'Smooth', 'Rough', 'Soft', 'Hard', 'Light', 'Heavy',
  'Fast', 'Slow', 'Big', 'Small', 'Huge', 'Tiny', 'Giant', 'Mini',
  'Hot', 'Cold', 'Warm', 'Cool', 'Spicy', 'Sweet', 'Sour', 'Bitter',
  'Happy', 'Sad', 'Angry', 'Calm', 'Excited', 'Bored', 'Curious', 'Lazy',
  'Brave', 'Scared', 'Proud', 'Humble', 'Lucky', 'Unlucky', 'Wise', 'Silly',
  'Funny', 'Serious', 'Playful', 'Quiet', 'Loud', 'Peaceful', 'Chaotic', 'Order',
  'Royal', 'Common', 'Noble', 'Simple', 'Complex', 'Easy', 'Hard', 'Tough',
  'Gentle', 'Rough', 'Polite', 'Rude', 'Kind', 'Mean', 'Nice', 'Nasty',
  'Clean', 'Dirty', 'Fresh', 'Stale', 'New', 'Old', 'Young', 'Mature',
  'Rich', 'Poor', 'Wealthy', 'Broke', 'Full', 'Empty', 'Complete', 'Broken',
  'Perfect', 'Flawed', 'Beautiful', 'Ugly', 'Pretty', 'Plain', 'Fancy', 'Simple',
  'Blue', 'Red', 'Green', 'Yellow', 'Black', 'White', 'Gray', 'Brown',
  'Violet', 'Indigo', 'Turquoise', 'Coral', 'Mint', 'Lime', 'Rose', 'Amber',
  'Electric', 'Neon', 'Glowing', 'Shimmering', 'Sparkling', 'Dazzling', 'Radiant'
];

const nouns = [
  'Dragon', 'Phoenix', 'Eagle', 'Wolf', 'Bear', 'Lion', 'Tiger', 'Panther',
  'Cobra', 'Viper', 'Shark', 'Whale', 'Dolphin', 'Octopus', 'Squid', 'Jellyfish',
  'Butterfly', 'Bee', 'Spider', 'Ant', 'Beetle', 'Cricket', 'Grasshopper', 'Moth',
  'Mountain', 'Valley', 'River', 'Ocean', 'Desert', 'Forest', 'Jungle', 'Prairie',
  'Thunder', 'Lightning', 'Storm', 'Rainbow', 'Sunset', 'Sunrise', 'Moon', 'Star',
  'Diamond', 'Ruby', 'Emerald', 'Sapphire', 'Pearl', 'Gold', 'Silver', 'Bronze',
  'Sword', 'Shield', 'Arrow', 'Bow', 'Hammer', 'Axe', 'Spear', 'Dagger',
  'Castle', 'Tower', 'Bridge', 'Gate', 'Wall', 'Door', 'Window', 'Roof',
  'Fire', 'Water', 'Earth', 'Air', 'Ice', 'Steam', 'Smoke', 'Flame',
  'Tree', 'Flower', 'Rose', 'Lily', 'Orchid', 'Tulip', 'Daisy', 'Sunflower',
  'Rock', 'Stone', 'Crystal', 'Gem', 'Boulder', 'Pebble', 'Sand', 'Dust',
  'Wind', 'Breeze', 'Gale', 'Hurricane', 'Tornado', 'Cyclone', 'Typhoon', 'Monsoon',
  'Knight', 'Wizard', 'Warrior', 'Archer', 'Mage', 'Paladin', 'Rogue', 'Bard',
  'Crown', 'Throne', 'Scepter', 'Orb', 'Ring', 'Necklace', 'Bracelet', 'Pendant',
  'Book', 'Scroll', 'Pen', 'Quill', 'Ink', 'Paper', 'Letter', 'Word',
  'Music', 'Song', 'Dance', 'Art', 'Paint', 'Brush', 'Canvas', 'Sculpture',
  'Ship', 'Boat', 'Sail', 'Anchor', 'Compass', 'Map', 'Treasure', 'Chest',
  'Clock', 'Time', 'Hour', 'Minute', 'Second', 'Day', 'Night', 'Dawn',
  'Dream', 'Hope', 'Wish', 'Love', 'Joy', 'Peace', 'Harmony', 'Unity',
  'Shadow', 'Light', 'Darkness', 'Brightness', 'Glow', 'Shine', 'Sparkle', 'Glitter',
  'Lagoon', 'Bay', 'Cove', 'Reef', 'Island', 'Coast', 'Beach', 'Shore',
  'Lobster', 'Crab', 'Shrimp', 'Turtle', 'Starfish', 'Seahorse', 'Clam', 'Oyster',
  'Galaxy', 'Comet', 'Planet', 'Asteroid', 'Nebula', 'Supernova', 'Meteor', 'Cosmos',
  'Thunder', 'Blizzard', 'Avalanche', 'Volcano', 'Earthquake', 'Tsunami', 'Tornado',
  'Hero', 'Legend', 'Champion', 'Guardian', 'Sentinel', 'Defender', 'Protector',
  'Blade', 'Fang', 'Claw', 'Talon', 'Horn', 'Spike', 'Thorn', 'Quill'
];

/**
 * Generates a random name by combining an adjective and a noun
 * @returns {string} A random name in the format "AdjectiveNoun"
 */
export function generateRandomName() {
  const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
  return `${randomAdjective}${randomNoun}`;
}

/**
 * Generates a unique random name by checking against existing names
 * @param {Function} checkNameExists - Function that returns a promise resolving to boolean indicating if name exists
 * @param {number} maxAttempts - Maximum number of attempts to generate a unique name
 * @returns {Promise<string>} A unique random name
 */
export async function generateUniqueRandomName(checkNameExists, maxAttempts = 10) {
  let attempts = 0;
  
  while (attempts < maxAttempts) {
    const name = generateRandomName();
    
    try {
      const exists = await checkNameExists(name);
      if (!exists) {
        return name;
      }
    } catch (error) {
      console.error('Error checking name uniqueness:', error);
      // If there's an error checking, return the name anyway
      return name;
    }
    
    attempts++;
  }
  
  // If we couldn't find a unique name after maxAttempts, append a random number
  const baseName = generateRandomName();
  const randomSuffix = Math.floor(Math.random() * 1000);
  return `${baseName}${randomSuffix}`;
}

export { adjectives, nouns };
